export enum FileInputAction {
    DROPPED = 'dropped',
    UNSUPPORTED = 'unsupported',
}
